/* eslint-disable react/jsx-key */
/* eslint-disable react/no-unknown-property */
/* eslint-disable no-useless-catch */
/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../Components/Header";
import SubHeader from "../Components/SubHeader";
import Loader from "../Components/Loader";
import Footer from "../Components/Footer";
import UniversalVideoPlayer from "../Components/YoutubePlayer";
import Cookies from "js-cookie";
import Mp3PlayerWidget from "../Components/Mp3PlayerWidget";

import {
  BookOpen,
  Users,
  Trophy,
  Zap,
  Target,
  TrendingUp,
  Star,
  Play,
  Clock,
  User,
  ChevronRight,
  Search,
  ArrowLeft,
  Calendar,
  Package,
  GraduationCap,
  Lightbulb,
  Globe,
  Award,
  Building,
  Home,
  School,
  X,
  Code,
} from "lucide-react";

import "../Styles/egitimler.css";

const withRouter = (Component) => {
  return (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    return <Component {...props} location={location} navigate={navigate} />;
  };
};

const AddReferenceCodeModal = ({ isOpen, onClose, onSuccess, API_BASE }) => {
  const [referenceCode, setReferenceCode] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);
  const [error, setError] = React.useState("");

  const getToken = () => {
    return Cookies.get("token") || localStorage.getItem("token") || "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!referenceCode.trim()) {
      setError("Lütfen referans kodunu giriniz.");
      return;
    }

    setIsLoading(true);
    setError("");

    try {
      const response = await fetch(
        `${API_BASE}/api/education/add-reference-code`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            token: getToken(),
            referenceCode: referenceCode.trim(),
          }),
        }
      );

      const result = await response.json();

      if (result.m === "basarili") {
        alert(result.message || "Referans kodu başarıyla eklendi!");
        onSuccess();
        onClose();
      } else {
        setError(result.message || "Bir hata oluştu.");
      }
    } catch (error) {
      setError("Bağlantı hatası. Lütfen tekrar deneyin.");
    }

    setIsLoading(false);
  };

  const handleClose = () => {
    setReferenceCode("");
    setError("");
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Referans Kodu Ekle</h3>
          <button className="modal-close-btn" onClick={handleClose}>
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="modal-body">
          <div className="form-group">
            <label htmlFor="referenceCode">Referans Kodu</label>
            <div className="input-with-icon">
              <Code size={20} className="input-icon" />
              <input
                id="referenceCode"
                type="text"
                value={referenceCode}
                onChange={(e) => setReferenceCode(e.target.value.toUpperCase())}
                placeholder="ABC123 formatında giriniz"
                className="form-input"
                disabled={isLoading}
              />
            </div>
          </div>

          {error && <div className="error-message">{error}</div>}

          <div className="modal-actions">
            <button
              type="button"
              onClick={handleClose}
              className="btn btn-secondary"
              disabled={isLoading}
            >
              İptal
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <div className="spinner"></div>
                  Ekleniyor...
                </>
              ) : (
                "Ekle"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

class Egitimler extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasEducationAccess: true,
      isCheckingAccess: false,
      showReferenceModal: false,

      mainCategories: [],
      currentItems: [],
      slugToIdMap: {},
      idToSlugMap: {},
      itemsCache: {},

      navPath: [],

      selectedCourse: null,
      lessonData: null,
      lessonContents: [],

      searchTerm: "",
      searchResults: [],
      isSearching: false,
      showSearchResults: false,
      searchError: null,
      loading: true,
      isLoadingMore: false,

      totalChildrenCount: 0,
      mainCategoriesNumberCount: 0,

      currentParentId: null,

      error: null,

      // Eğitim tamamlama (10 dk kuralı)
      isCompleted: false,
      isButtonEnabled: false,
      isToggling: false,
      remainingSeconds: 600,
      completionMessage: "",

      // İzlenen / İzlenmeyen eğitim takibi
      activeTab: "all", // "all" | "watched" | "unwatched"
      trackItems: [],
      trackCount: 0,
      trackLoading: false,
      trackLoadingMore: false,
    };

    this.API_BASE = process.env.REACT_APP_API_URL;
    this.searchTimer = null;
    this.countdownTimer = null;
    this.pageOpenTime = null;
  }

  componentDidMount() {
    if (!Cookies.get("token")) {
      const currentPath = window.location.pathname;
      sessionStorage.setItem("redirectAfterLogin", currentPath);
      window.location.href = "/login";
      return;
    }
    this.checkEducationAccess();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      if (this.state.hasEducationAccess && !this.state.isCheckingAccess) {
        this.initializeData();
      }
    }
  }

  componentWillUnmount() {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  }

  // ==================== Eğitim Tamamlama (10 dk kuralı) ====================

  // Bir kursa girildiğinde tamamlanma durumunu kontrol et ve sayacı başlat
  initCompletionForCourse = async (courseId) => {
    // Önceki sayacı temizle, state'i sıfırla
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
      this.countdownTimer = null;
    }
    this.pageOpenTime = Date.now();
    this.setState({
      isCompleted: false,
      isButtonEnabled: false,
      isToggling: false,
      remainingSeconds: 600,
      completionMessage: "",
    });

    try {
      const response = await this.apiRequest("/api/education/check-completion", {
        token: this.getToken(),
        egitim_id: courseId,
      });

      if (response.m === "basarili" && response.isCompleted) {
        // Zaten tamamlanmış: sayacı bekletme, "geri çek" durumuna geç
        this.setState({
          isCompleted: true,
          isButtonEnabled: true,
          remainingSeconds: 0,
        });
        return;
      }
    } catch (e) {
      console.error("Tamamlama durumu kontrol hatası:", e);
    }

    // Tamamlanmamış: 10 dakikalık sayacı başlat
    this.startCountdown();
  };

  startCountdown = () => {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
    this.countdownTimer = setInterval(() => {
      if (!this.pageOpenTime) return;
      const elapsed = Math.floor((Date.now() - this.pageOpenTime) / 1000);
      const remaining = 600 - elapsed;
      if (remaining <= 0) {
        this.setState({ isButtonEnabled: true, remainingSeconds: 0 });
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      } else {
        this.setState({ remainingSeconds: remaining });
      }
    }, 1000);
  };

  formatRemaining = (totalSeconds) => {
    const m = Math.floor(totalSeconds / 60);
    const s = totalSeconds % 60;
    return `${m}:${s.toString().padStart(2, "0")}`;
  };

  handleToggleCompletion = async () => {
    const { selectedCourse, isButtonEnabled, isToggling, isCompleted } = this.state;
    if (!selectedCourse) return;

    // 10 dk dolmadan tamamlamaya çalışırsa uyar (istemci tarafı erken tespit)
    if (!isCompleted && !isButtonEnabled) {
      this.setState({
        completionMessage: `Eğitimi tamamlamak için lütfen en az 10 dakika izleyin. Kalan süre: ${this.formatRemaining(
          this.state.remainingSeconds
        )}`,
      });
      return;
    }

    if (isToggling) return;
    this.setState({ isToggling: true, completionMessage: "" });

    try {
      const result = await this.apiRequest("/api/education/toggle-complete", {
        token: this.getToken(),
        egitim_id: selectedCourse.id,
      });

      if (result.m === "bekleme_suresi") {
        // Sunucu 10 dk kuralını uyguladı: kalan süreye göre sayacı yeniden başlat
        const kalan = result.kalanSaniye;
        if (typeof kalan === "number" && kalan > 0) {
          this.pageOpenTime = Date.now() - (600 - kalan) * 1000;
          this.setState({ isButtonEnabled: false, remainingSeconds: kalan });
          this.startCountdown();
        }
        this.setState({
          isToggling: false,
          completionMessage:
            result.message ||
            "Yeni bir eğitimi tamamlamak için biraz beklemelisiniz.",
        });
        return;
      }

      if (result.m === "basarili") {
        const nowCompleted = result.isCompleted ?? false;
        this.setState({
          isCompleted: nowCompleted,
          isToggling: false,
          isButtonEnabled: true,
          remainingSeconds: 0,
          completionMessage: nowCompleted
            ? "🎉 Eğitimi tamamladınız! Puanınız eklendi."
            : "Tamamlama geri çekildi.",
        });
      } else {
        this.setState({
          isToggling: false,
          completionMessage: "Bir hata oluştu. Lütfen tekrar deneyin.",
        });
      }
    } catch (e) {
      console.error("Toggle hatası:", e);
      this.setState({
        isToggling: false,
        completionMessage: "Bir hata oluştu. Lütfen tekrar deneyin.",
      });
    }
  };

  // ==================== İzlenen / İzlenmeyen Eğitimler ====================

  handleTabChange = (tab) => {
    this.setState({ activeTab: tab }, () => {
      if (tab === "all") return;
      this.loadTrackList(tab, true);
    });
  };

  loadTrackList = async (tab, reset = false) => {
    const endpoint =
      tab === "watched"
        ? "/api/education/get-watched-educations"
        : "/api/education/get-unwatched-educations";

    this.setState(
      reset
        ? { trackLoading: true, trackItems: [], trackCount: 0 }
        : { trackLoadingMore: true }
    );

    try {
      const offset = reset ? 0 : this.state.trackItems.length;
      const response = await this.apiRequest(endpoint, {
        token: this.getToken(),
        offset,
      });

      if (response.m === "basarili") {
        const newItems = (response.data || []).map((item) => ({
          id: item.id,
          title: item.page_name,
          subtitle: item.page_subtitle || "",
          image: item.web_image_url || item.mobil_image_url,
          instructor: item.educatorName,
          date: item.tamamlanma_tarihi
            ? this.formatTurkishDate(item.tamamlanma_tarihi)
            : item.educationDate
            ? this.formatTurkishDate(item.educationDate)
            : "",
          cardType: "education",
        }));

        this.setState((prevState) => ({
          trackItems: reset ? newItems : [...prevState.trackItems, ...newItems],
          trackCount: response.kayitSayisi || 0,
          trackLoading: false,
          trackLoadingMore: false,
        }));
      } else {
        this.setState({ trackLoading: false, trackLoadingMore: false });
      }
    } catch (e) {
      console.error("İzleme listesi yükleme hatası:", e);
      this.setState({ trackLoading: false, trackLoadingMore: false });
    }
  };

  checkEducationAccess = async () => {
    this.setState({
      hasEducationAccess: true,
      isCheckingAccess: false,
    });
    this.initializeData();
  };

  handleShowReferenceModal = () => {
    this.setState({ showReferenceModal: true });
  };

  handleCloseReferenceModal = () => {
    this.setState({ showReferenceModal: false });
  };

  handleReferenceCodeSuccess = () => {
    this.setState({
      showReferenceModal: false,
      isCheckingAccess: true,
    });
    this.checkEducationAccess();
  };

  createSlug = (text) => {
    if (!text) return "";

    let decodedText = text;
    try {
      while (decodedText !== decodeURIComponent(decodedText)) {
        decodedText = decodeURIComponent(decodedText);
      }
    } catch (e) {
      decodedText = text;
    }

    return decodedText
      .toLowerCase()
      .trim()
      .replace(/ğ/gi, "g")
      .replace(/ü/gi, "u")
      .replace(/ş/gi, "s")
      .replace(/ı/gi, "i")
      .replace(/İ/g, "i")
      .replace(/i̇/g, "i")
      .replace(/ö/gi, "o")
      .replace(/ç/gi, "c")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .replace(/-+/g, "-");
  };

  createUniqueSlug = (text, id) => {
    const baseSlug = this.createSlug(text);

    const finalSlug = `${baseSlug}-${id}`;

    return finalSlug;
  };


  extractIdFromSlug = (slug) => {
    const parts = slug.split("-");
    const lastPart = parts[parts.length - 1];

    const id = parseInt(lastPart, 10);

    if (!isNaN(id)) {
      return id;
    }

    return null;
  };

  updateMappings = (id, name, slug = null) => {
    if (!slug) {
      slug = this.createUniqueSlug(name, id);
    }

    this.setState((prevState) => ({
      slugToIdMap: {
        ...prevState.slugToIdMap,
        [slug]: id,
      },
      idToSlugMap: {
        ...prevState.idToSlugMap,
        [id]: slug,
      },
      itemsCache: {
        ...prevState.itemsCache,
        [id]: { name, slug },
      },
    }));

    return slug;
  };

  initializeData = () => {
    const { location } = this.props;
    const pathSegments = location.pathname
      .replace("/egitimler", "")
      .split("/")
      .filter((segment) => segment !== "");

    this.setState({
      loading: true,
      error: null,
      navPath: [],
      currentItems: [],
      selectedCourse: null,
    });

    if (pathSegments.length === 0) {
      this.loadMainCategories();
    } else {
      this.parseUrlAndLoad(pathSegments);
    }
  };

  parseUrlAndLoad = async (slugSegments) => {
    try {
      const decodedSlugs = slugSegments.map(slug => {
        try {
          return decodeURIComponent(slug);
        } catch (e) {
          return slug;
        }
      });

      const idChain = await this.resolveSlugChain(decodedSlugs);

      if (idChain.length === 0) {
        this.props.navigate("/egitimler");
        return;
      }

      const lastId = idChain[idChain.length - 1];
      const itemType = await this.determineItemType(lastId);

      if (itemType === "category") {
        await this.validateAndLoadCategory(lastId, decodedSlugs, idChain);
      } else if (itemType === "course") {
        await this.validateAndLoadCourse(lastId, decodedSlugs, idChain);
      } else {
        this.setState({
          error: "İçerik bulunamadı",
          loading: false,
        });
      }
    } catch (error) {
      this.setState({
        error: "Geçersiz URL",
        loading: false,
      });
    }
  };


  resolveSlugChain = async (slugSegments) => {
    const idChain = [];

    for (let i = 0; i < slugSegments.length; i++) {
      const slug = slugSegments[i];
      let id = this.state.slugToIdMap[slug];

      if (!id) {
        try {
          id = await this.findIdBySlugInHierarchy(slug, idChain);
          if (!id) {
            return [];
          }
        } catch (error) {
          return [];
        }
      }

      idChain.push(id);
    }

    return idChain;
  };


  findIdBySlugInHierarchy = async (targetSlug, parentChain) => {
    try {
      console.log("🔍 Slug araniyor:", targetSlug, "Parent chain:", parentChain);

      const extractedId = this.extractIdFromSlug(targetSlug);
      console.log("📌 Extracted ID:", extractedId);

      const parentId = parentChain.length > 0 ? parentChain[parentChain.length - 1] : null;
      console.log("👆 Parent ID:", parentId);

      if (parentId === null) {
        let offset = 0;
        let allItems = [];
        let hasMore = true;

        while (hasMore) {
          const response = await this.apiRequest(
            "/api/education/get-main-categories",
            {
              token: this.getToken(),
              offset: offset,
            }
          );

          console.log("📦 Ana kategoriler response (offset:", offset, "):", response);

          if (response.m === "basarili" && response.data.length > 0) {
            allItems = [...allItems, ...response.data];
            offset += response.data.length;

            hasMore = allItems.length < response.kayitSayisi;
          } else {
            hasMore = false;
          }
        }

        console.log("📊 Toplam ana kategori:", allItems.length);

        if (extractedId) {
          const itemById = allItems.find(i => i.id === extractedId);
          if (itemById) {
            console.log("✅ ID ile bulundu:", itemById);
            const uniqueSlug = this.createUniqueSlug(itemById.page_name, itemById.id);
            this.updateMappings(itemById.id, itemById.page_name, uniqueSlug);
            return itemById.id;
          }
        }

        for (const item of allItems) {
          const itemSlug = this.createUniqueSlug(item.page_name, item.id);
          console.log(`  Karşılaştırma: "${itemSlug}" === "${targetSlug}"`);

          if (itemSlug === targetSlug) {
            console.log("✅ Slug ile bulundu:", item);
            this.updateMappings(item.id, item.page_name, itemSlug);
            return item.id;
          }
        }
      } else {
        let offset = 0;
        let allItems = [];
        let hasMore = true;

        while (hasMore) {
          const response = await this.apiRequest(
            "/api/education/getItemsByParentId",
            {
              token: this.getToken(),
              parent_id: parentId,
              offset: offset,
            }
          );

          console.log("📦 Alt kategoriler response (offset:", offset, "):", response);

          if (response.m === "basarili" && response.data.length > 0) {
            allItems = [...allItems, ...response.data];
            offset += response.data.length;

            hasMore = allItems.length < response.kayitSayisi;
          } else {
            hasMore = false;
          }
        }

        console.log("📊 Toplam alt kategori:", allItems.length);

        if (extractedId) {
          const itemById = allItems.find(i => i.id === extractedId);
          if (itemById) {
            console.log("✅ ID ile bulundu:", itemById);
            const uniqueSlug = this.createUniqueSlug(itemById.page_name, itemById.id);
            this.updateMappings(itemById.id, itemById.page_name, uniqueSlug);
            return itemById.id;
          }
        }

        for (const item of allItems) {
          const itemSlug = this.createUniqueSlug(item.page_name, item.id);
          console.log(`  Karşılaştırma: "${itemSlug}" === "${targetSlug}"`);

          if (itemSlug === targetSlug) {
            console.log("✅ Slug ile bulundu:", item);
            this.updateMappings(item.id, item.page_name, itemSlug);
            return item.id;
          }
        }
      }

      console.error("❌ Slug bulunamadı:", targetSlug);
      return null;
    } catch (error) {
      console.error("❌ findIdBySlugInHierarchy hatası:", error);
      return null;
    }
  };

  determineItemType = async (itemId) => {
    try {
      const categoryResponse = await this.apiRequest(
        "/api/education/getItemsByParentId",
        {
          token: this.getToken(),
          parent_id: itemId,
          offset: 0,
        }
      );

      if (
        categoryResponse.m === "basarili" &&
        categoryResponse.data &&
        categoryResponse.data.length > 0
      ) {
        return "category";
      }

      const courseResponse = await this.apiRequest(
        "/api/education/get-lessoncontents",
        {
          token: this.getToken(),
          id: itemId.toString(),
        }
      );

      if (courseResponse.m === "basarili") {
        return "course";
      }

      return null;
    } catch (error) {
      return null;
    }
  };

  validateAndLoadCategory = async (categoryId, currentSlugs, idChain) => {
    try {
      const pathResponse = await this.apiRequest(
        "/api/education/getPathInfoForParent",
        {
          token: this.getToken(),
          parentId: categoryId,
          fromDirectSearch: "false",
        }
      );

      let correctPath = [];
      if (pathResponse.m === "basarili") {
        correctPath = pathResponse.data;
      }

      const correctSlugs = [];
      for (const pathItem of correctPath) {
        const cleanName = pathItem.name.replace("> ", "");
        const slug = this.createUniqueSlug(cleanName, pathItem.id);
        this.updateMappings(pathItem.id, cleanName, slug);
        correctSlugs.push(slug);
      }

      const correctUrl = `/egitimler/${correctSlugs.join("/")}`;
      const currentUrl = `/egitimler/${currentSlugs.join("/")}`;

      if (correctUrl !== currentUrl) {
        this.props.navigate(correctUrl, { replace: true });
        return;
      }

      await this.loadCategoryItems(categoryId);
    } catch (error) {
      this.setState({
        error: "Kategori yüklenemedi",
        loading: false,
      });
    }
  };

  validateAndLoadCourse = async (courseId, currentSlugs, idChain) => {
    try {
      const courseResponse = await this.apiRequest(
        "/api/education/get-lessoncontents",
        {
          token: this.getToken(),
          id: courseId.toString(),
        }
      );

      if (courseResponse.m !== "basarili") {
        throw new Error("Kurs bulunamadı");
      }

      let correctPath = [];
      if (courseResponse.data.parent_id) {
        const pathResponse = await this.apiRequest(
          "/api/education/getPathInfoForParent",
          {
            token: this.getToken(),
            parentId: courseResponse.data.parent_id,
            fromDirectSearch: "false",
          }
        );

        if (pathResponse.m === "basarili") {
          correctPath = pathResponse.data;
        }
      }

      correctPath.push({
        id: courseId,
        name: courseResponse.data.page_name,
      });

      const correctSlugs = [];
      for (const pathItem of correctPath) {
        const cleanName = pathItem.name.replace("> ", "");
        const slug = this.createUniqueSlug(cleanName, pathItem.id);
        this.updateMappings(pathItem.id, cleanName, slug);
        correctSlugs.push(slug);
      }

      const correctUrl = `/egitimler/${correctSlugs.join("/")}`;
      const currentUrl = `/egitimler/${currentSlugs.join("/")}`;

      if (correctUrl !== currentUrl) {
        this.props.navigate(correctUrl, { replace: true });
        return;
      }

      await this.loadCourseDetailsFromData(
        courseId,
        courseResponse.data,
        correctPath
      );
    } catch (error) {
      this.setState({
        error: "Kurs yüklenemedi",
        loading: false,
      });
    }
  };


  loadMainCategories = async () => {
    try {
      const response = await this.apiRequest(
        "/api/education/get-main-categories",
        {
          token: this.getToken(),
          offset: 0,
        }
      );

      if (response.m === "basarili") {
        const formattedCategories = response.data.map((item) => {
          const uniqueSlug = this.createUniqueSlug(item.page_name, item.id);
          this.updateMappings(item.id, item.page_name, uniqueSlug);

          return {
            id: item.id,
            title: item.page_name,
            subtitle: item.page_subtitle || "",
            image: item.web_image_url || item.mobil_image_url,
            backgroundColor: item.background_color || "#B7C9F2",
            borderColor: item.border_color || "#B7C9F2",
            cardType: "category",
          };
        });

        this.setState({
          currentItems: formattedCategories,
          mainCategories: formattedCategories,
          mainCategoriesNumberCount: response.kayitSayisi,
          totalChildrenCount: response.kayitSayisi,
          loading: false,
          navPath: [],
        });
      } else {
        throw new Error(response.message || "Ana kategoriler yüklenemedi");
      }
    } catch (error) {
      this.setState({
        error: error.message,
        loading: false,
      });
    }
  };

  loadCategoryItems = async (parentId) => {
    try {
      const [itemsResponse, pathResponse] = await Promise.all([
        this.apiRequest("/api/education/getItemsByParentId", {
          token: this.getToken(),
          parent_id: parentId,
          offset: 0,
        }),
        this.apiRequest("/api/education/getPathInfoForParent", {
          token: this.getToken(),
          parentId: parentId,
          fromDirectSearch: "false",
        }),
      ]);

      let newNavPath = [];
      if (pathResponse.m === "basarili") {
        newNavPath = pathResponse.data.map((item) => {
          const cleanName = item.name.replace("> ", "");
          const uniqueSlug = this.createUniqueSlug(cleanName, item.id);
          this.updateMappings(item.id, cleanName, uniqueSlug);

          return {
            name: cleanName,
            id: item.id,
          };
        });
      }

      if (itemsResponse.m === "basarili") {
        const formattedItems = itemsResponse.data.map((item) => {
          const uniqueSlug = this.createUniqueSlug(item.page_name, item.id);
          this.updateMappings(item.id, item.page_name, uniqueSlug);

          const baseItem = {
            id: item.id,
            title: item.page_name,
            subtitle: item.page_subtitle || item.educationContent || "",
            image: item.web_image_url || item.mobil_image_url,
            date: item.educationDate
              ? this.formatTurkishDate(item.educationDate)
              : "",
            instructor: item.educatorName,
          };

          if (item.type === "Ana Kategori" || item.type === "Kategori") {
            return {
              ...baseItem,
              cardType: "category",
              backgroundColor: item.background_color || "#B7C9F2",
              borderColor: item.border_color || "#B7C9F2",
            };
          } else if (item.type === "Ders İçeriği") {
            return {
              ...baseItem,
              cardType: "education",
            };
          }
          return baseItem;
        });

        this.setState({
          currentItems: formattedItems,
          navPath: newNavPath,
          totalChildrenCount: itemsResponse.kayitSayisi,
          currentParentId: parentId,
          loading: false,
        });
      } else {
        throw new Error(
          itemsResponse.message || "Kategori içerikleri yüklenemedi"
        );
      }
    } catch (error) {
      this.setState({
        error: error.message,
        loading: false,
      });
    }
  };

  loadMoreItems = async () => {
    const { currentParentId, currentItems } = this.state;

    if (!currentParentId) return;

    this.setState({ isLoadingMore: true });

    try {
      const response = await this.apiRequest(
        "/api/education/getItemsByParentId",
        {
          token: this.getToken(),
          parent_id: currentParentId,
          offset: currentItems.length,
        }
      );

      if (response.m === "basarili") {
        const newItems = response.data.map((item) => {
          const uniqueSlug = this.createUniqueSlug(item.page_name, item.id);
          this.updateMappings(item.id, item.page_name, uniqueSlug);

          const baseItem = {
            id: item.id,
            title: item.page_name,
            subtitle: item.page_subtitle || item.educationContent || "",
            image: item.web_image_url || item.mobil_image_url,
            date: item.educationDate
              ? this.formatTurkishDate(item.educationDate)
              : "",
            instructor: item.educatorName,
          };

          if (item.type === "Ana Kategori" || item.type === "Kategori") {
            return {
              ...baseItem,
              cardType: "category",
              backgroundColor: item.background_color || "#B7C9F2",
              borderColor: item.border_color || "#B7C9F2",
            };
          } else if (item.type === "Ders İçeriği") {
            return {
              ...baseItem,
              cardType: "education",
            };
          }
          return baseItem;
        });

        this.setState((prevState) => ({
          currentItems: [...prevState.currentItems, ...newItems],
          isLoadingMore: false,
        }));
      } else {
        this.setState({ isLoadingMore: false });
      }
    } catch (error) {
      this.setState({ isLoadingMore: false });
      console.error("Error loading more items:", error);
    }
  };

  loadCourseDetailsFromData = (courseId, courseData, pathItems) => {
    try {
      const lessonContents = courseData.lesson_contents || [];
      lessonContents.sort(
        (a, b) => (a.order_index || 0) - (b.order_index || 0)
      );

      const newNavPath = pathItems.map((item) => ({
        name: item.name.replace("> ", ""),
        id: item.id,
      }));

      this.setState({
        lessonData: courseData,
        lessonContents: lessonContents,
        navPath: newNavPath,
        selectedCourse: {
          id: courseId,
          title: courseData.page_name,
          description: courseData.educationContent,
          instructor: courseData.educatorName,
          image: courseData.web_image_url || courseData.mobil_image_url,
          parentId: courseData.parent_id,
          podcast_url: courseData.podcast_url || null,
          podcast_title: courseData.podcast_title || null,
        },
        loading: false,
      });

      // Tamamlanma durumunu kontrol et ve 10 dk sayacını başlat
      this.initCompletionForCourse(courseId);
    } catch (error) {
      this.setState({
        error: error.message,
        loading: false,
      });
    }
  };

  searchCourses = async (searchQuery) => {
    try {
      const response = await this.apiRequest("/api/education/search-course", {
        token: this.getToken(),
        searchQuery: searchQuery.trim(),
      });

      if (response.m === "basarili") {
        return response.data || [];
      } else {
        throw new Error("Arama işlemi başarısız");
      }
    } catch (error) {
      throw error;
    }
  };

  navigateToCourse = async (courseId) => {
    try {
      const courseResponse = await this.apiRequest(
        "/api/education/get-lessoncontents",
        {
          token: this.getToken(),
          id: courseId.toString(),
        }
      );

      if (courseResponse.m !== "basarili") {
        throw new Error("Kurs bulunamadı");
      }

      let pathItems = [];
      if (courseResponse.data.parent_id) {
        const pathResponse = await this.apiRequest(
          "/api/education/getPathInfoForParent",
          {
            token: this.getToken(),
            parentId: courseResponse.data.parent_id,
            fromDirectSearch: "false",
          }
        );

        if (pathResponse.m === "basarili") {
          pathItems = pathResponse.data;
        }
      }

      pathItems.push({
        id: courseId,
        name: courseResponse.data.page_name,
      });

      const slugs = pathItems.map((item) => {
        const cleanName = item.name.replace("> ", "");
        return this.updateMappings(item.id, cleanName);
      });

      const courseUrl = `/egitimler/${slugs.join("/")}`;
      this.props.navigate(courseUrl);
    } catch (error) {
      alert("Kurs yüklenemedi");
    }
  };

  navigateToCategory = async (categoryId) => {
    try {
      const pathResponse = await this.apiRequest(
        "/api/education/getPathInfoForParent",
        {
          token: this.getToken(),
          parentId: categoryId,
          fromDirectSearch: "false",
        }
      );

      let pathItems = [];
      if (pathResponse.m === "basarili") {
        pathItems = pathResponse.data;
      }

      const slugs = pathItems.map((item) => {
        const cleanName = item.name.replace("> ", "");
        return this.updateMappings(item.id, cleanName);
      });

      const categoryUrl = `/egitimler/${slugs.join("/")}`;
      this.props.navigate(categoryUrl);
    } catch (error) {
      alert("Kategori yüklenemedi");
    }
  };

  handleSearchResultClick = async (result) => {
    try {
      this.setState({
        showSearchResults: false,
        searchTerm: "",
      });

      if (result.cardType === "education") {
        await this.navigateToCourse(result.id);
      } else {
        await this.navigateToCategory(result.id);
      }
    } catch (error) { }
  };

  apiRequest = async (endpoint, body) => {
    const response = await fetch(`${this.API_BASE}${endpoint}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    return result;
  };

  getToken = () => {
    return Cookies.get("token") || localStorage.getItem("token") || "";
  };

  formatTurkishDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("tr-TR", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    } catch (error) {
      return "Geçersiz tarih";
    }
  };

  buildUrlFromPath = (pathItems) => {
    if (!pathItems || pathItems.length === 0) {
      return "/egitimler";
    }

    const slugs = pathItems.map(
      (item) => this.state.idToSlugMap[item.id] || this.createSlug(item.name)
    );
    return `/egitimler/${slugs.join("/")}`;
  };

  handleCategoryClick = (category) => {
    const { navPath } = this.state;

    const newPathItems = [
      ...navPath,
      { id: category.id, name: category.title },
    ];
    const newUrl = this.buildUrlFromPath(newPathItems);

    this.props.navigate(newUrl);
  };

  handleCourseClick = (course) => {
    const { navPath } = this.state;

    const newPathItems = [...navPath, { id: course.id, name: course.title }];
    const newUrl = this.buildUrlFromPath(newPathItems);

    this.props.navigate(newUrl);
  };

  handleBackNavigation = () => {
    const { navPath, selectedCourse } = this.state;

    if (selectedCourse) {
      if (navPath.length > 1) {
        const parentPath = navPath.slice(0, -1);
        const parentUrl = this.buildUrlFromPath(parentPath);
        this.props.navigate(parentUrl);
      } else {
        this.props.navigate("/egitimler");
      }
    } else if (navPath.length <= 1) {
      this.props.navigate("/egitimler");
    } else {
      const previousPath = navPath.slice(0, -1);
      const previousUrl = this.buildUrlFromPath(previousPath);
      this.props.navigate(previousUrl);
    }
  };

  handleBreadcrumbClick = (item, index) => {
    const { navPath } = this.state;

    if (index === 0) {
      this.props.navigate("/egitimler");
    } else {
      const targetPath = navPath.slice(0, index);
      const targetUrl = this.buildUrlFromPath(targetPath);
      this.props.navigate(targetUrl);
    }
  };

  handleSearch = (e) => {
    const searchTerm = e.target.value;

    this.setState({
      searchTerm,
      searchError: null,
    });

    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }

    if (!searchTerm.trim()) {
      this.setState({
        searchResults: [],
        showSearchResults: false,
        isSearching: false,
      });
      return;
    }

    this.setState({ isSearching: true });

    this.searchTimer = setTimeout(async () => {
      try {
        const results = await this.searchCourses(searchTerm);

        const formattedResults = results.map((item) => ({
          id: item.id,
          title: item.title,
          subtitle: item.description || "",
          category: item.category,
          cardType: item.category === "Ders İçeriği" ? "education" : "category",
        }));

        this.setState({
          searchResults: formattedResults,
          showSearchResults: true,
          isSearching: false,
        });
      } catch (error) {
        this.setState({
          searchError: "Arama sırasında bir hata oluştu",
          searchResults: [],
          showSearchResults: false,
          isSearching: false,
        });
      }
    }, 300);
  };

  handleSearchBlur = () => {
    setTimeout(() => {
      this.setState({
        showSearchResults: false,
      });
    }, 200);
  };

  getFilteredItems = () => {
    const { currentItems, searchTerm, showSearchResults } = this.state;

    if (showSearchResults) {
      return currentItems;
    }

    if (!searchTerm) return currentItems;

    return currentItems.filter(
      (item) =>
        item.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (item.subtitle &&
          item.subtitle.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (item.instructor &&
          item.instructor.toLowerCase().includes(searchTerm.toLowerCase()))
    );
  };

  buildImageUrl = (imagePath) => {
    if (!imagePath) return "";

    if (imagePath.startsWith("http://") || imagePath.startsWith("https://")) {
      return imagePath;
    }

    return `${this.API_BASE
      }/api/files/?filepath=${imagePath}&token=${this.getToken()}`;
  };

  renderAccessControlScreen = () => {
    const { isCheckingAccess } = this.state;

    if (isCheckingAccess) {
      return (
        <div className="egitimler-container">
          <div className="container text-center" style={{ padding: "100px 0" }}>
            <div className="access-loading">
              <div className="access-spinner"></div>
              <h4>Eğitim erişimi kontrol ediliyor...</h4>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="egitimler-container">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-6 col-md-8 mt-3">
              <div className="access-control-card">
                <div className="access-icon">
                  <School size={80} color="#3b82f6" />
                </div>

                <h2 className="access-title">Eğitimlere Erişim</h2>

                <p className="access-description">Referans Kodu Giriniz</p>

                <button
                  className="access-button"
                  onClick={this.handleShowReferenceModal}
                >
                  Referans Kodu Ekle
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderSearchResults = () => {
    const { searchResults, showSearchResults, isSearching, searchError } =
      this.state;

    if (!showSearchResults && !isSearching) return null;

    return (
      <div className="search-results-dropdown">
        {isSearching ? (
          <div className="search-result-item searching">
            <div className="search-loading">
              <div className="search-spinner"></div>
              Aranıyor...
            </div>
          </div>
        ) : searchError ? (
          <div className="search-result-item error">
            <div className="search-error">⚠️ {searchError}</div>
          </div>
        ) : searchResults.length === 0 ? (
          <div className="search-result-item no-results">
            <div className="search-no-results">🔍 Sonuç bulunamadı</div>
          </div>
        ) : (
          <>
            <div className="search-results-header">
              Arama Sonuçları ({searchResults.length})
            </div>
            {searchResults.map((result) => (
              <div
                key={result.id}
                className="search-result-item clickable"
                onClick={() => this.handleSearchResultClick(result)}
              >
                <div className="search-result-content">
                  <div className="search-result-title">{result.title}</div>
                  {result.subtitle && (
                    <div className="search-result-subtitle">
                      {result.subtitle}
                    </div>
                  )}
                  <div className="search-result-category">
                    {result.category === "Ders İçeriği"
                      ? "🎓 Eğitim"
                      : "📁 Kategori"}
                  </div>
                </div>
                <ChevronRight size={16} className="search-result-arrow" />
              </div>
            ))}
          </>
        )}
      </div>
    );
  };

  renderBreadcrumbs = () => {
    const { navPath } = this.state;

    if (navPath.length === 0) return null;

    const breadcrumbs = [
      { name: "Eğitimler", path: "/egitimler", icon: Home, isHome: true },
      ...navPath.map((item, index) => {
        const targetPath = navPath.slice(0, index + 1);
        const targetUrl = this.buildUrlFromPath(targetPath);

        return {
          name: item.name,
          path: targetUrl,
          id: item.id,
          isHome: false,
        };
      }),
    ];

    return (
      <div className="breadcrumb-section">
        <div className="container">
          <div className="breadcrumb-wrapper">
            {breadcrumbs.map((breadcrumb, index) => (
              <React.Fragment key={index}>
                <button
                  className={`breadcrumb-item ${index === breadcrumbs.length - 1 ? "active" : ""
                    }`}
                  onClick={() => {
                    if (index !== breadcrumbs.length - 1) {
                      if (breadcrumb.isHome) {
                        this.props.navigate("/egitimler");
                      } else {
                        this.handleBreadcrumbClick(breadcrumb, index);
                      }
                    }
                  }}
                  disabled={index === breadcrumbs.length - 1}
                >
                  {breadcrumb.icon &&
                    React.createElement(breadcrumb.icon, { size: 16 })}
                  {breadcrumb.name}
                </button>
                {index < breadcrumbs.length - 1 && (
                  <ChevronRight size={14} className="breadcrumb-separator" />
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    );
  };

  renderCategoryCard = (item) => {
    return (
      <div key={item.id} className="col-lg-4 col-md-6 mb-40">
        <div
          className="category-card"
          onClick={() => this.handleCategoryClick(item)}
        >
          <div className="category-shadow" />
          <div className="category-pattern" />

          <div className="category-content">
            <div className="category-icon">
              {item.image ? (
                <img
                  src={this.buildImageUrl(item.image)}
                  alt={item.title}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
              ) : (
                <Package size={30} />
              )}
            </div>

            <h4 className="category-title">{item.title}</h4>

            <p className="category-desc">{item.subtitle}</p>
          </div>

          <div className="category-link">
            İçerikleri Görüntüle
            <ChevronRight size={16} style={{ marginLeft: "5px" }} />
          </div>
        </div>
      </div>
    );
  };

  renderEducationCard = (item, onClick) => {
    const handleClick = onClick || (() => this.handleCourseClick(item));
    return (
      <div key={item.id} className="col-lg-6 col-md-12 mb-40">
        <div className="course-card">
          <div className="course-shadow" />

          <div className="course-thumbnail">
            {item.image ? (
              <img
                src={this.buildImageUrl(item.image)}
                alt={item.title}
                className="course-image"
                onError={(e) => {
                  e.target.src =
                    "https://via.placeholder.com/400x200?text=Eğitim";
                }}
              />
            ) : (
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  background: "#f1f5f9",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Play size={48} color="#64748b" />
              </div>
            )}

            <div className="play-overlay">
              <Play size={24} fill="white" />
            </div>

            {item.date && (
              <div
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  background: "rgba(7, 11, 46, 0.9)",
                  color: "white",
                  padding: "5px 10px",
                  borderRadius: "20px",
                  fontSize: "12px",
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                <Calendar size={12} />
                {item.date}
              </div>
            )}
          </div>

          <div className="course-content">
            <div>
              {item.instructor && (
                <div className="course-meta">
                  <User size={14} />
                  {item.instructor}
                </div>
              )}

              <h5 className="course-title">{item.title}</h5>

              {item.subtitle && (
                <p className="course-description">{item.subtitle}</p>
              )}
            </div>

            <button className="course-button" onClick={handleClick}>
              Eğitimi İzle
            </button>
          </div>
        </div>
      </div>
    );
  };

  renderTabBar = () => {
    const { activeTab } = this.state;
    const tabs = [
      { key: "all", label: "Tüm Eğitimler", icon: BookOpen },
      { key: "watched", label: "İzlediklerim", icon: Award },
      { key: "unwatched", label: "İzlemediklerim", icon: Clock },
    ];

    return (
      <div className="container" style={{ marginTop: "20px" }}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            justifyContent: "center",
            marginBottom: "10px",
          }}
        >
          {tabs.map((tab) => {
            const active = activeTab === tab.key;
            return (
              <button
                key={tab.key}
                onClick={() => this.handleTabChange(tab.key)}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  padding: "10px 22px",
                  borderRadius: "25px",
                  border: active ? "2px solid #3b82f6" : "2px solid #e2e8f0",
                  background: active ? "#3b82f6" : "transparent",
                  color: active ? "white" : "#64748b",
                  fontSize: "15px",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                }}
              >
                {React.createElement(tab.icon, { size: 16 })}
                {tab.label}
              </button>
            );
          })}
        </div>
      </div>
    );
  };

  renderTrackList = () => {
    const {
      activeTab,
      trackItems,
      trackCount,
      trackLoading,
      trackLoadingMore,
    } = this.state;

    if (trackLoading) {
      return (
        <div className="row">
          <div className="col-12 text-center" style={{ padding: "60px 0" }}>
            <div
              className="spinner-border"
              role="status"
              style={{ color: "#3b82f6" }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            <p style={{ marginTop: "15px", color: "#64748b" }}>Yükleniyor...</p>
          </div>
        </div>
      );
    }

    if (trackItems.length === 0) {
      return (
        <div className="row">
          <div className="col-12 text-center no-results">
            <div className="no-results-card">
              {activeTab === "watched" ? (
                <Award
                  size={48}
                  color="#64748b"
                  style={{ marginBottom: "20px" }}
                />
              ) : (
                <Clock
                  size={48}
                  color="#64748b"
                  style={{ marginBottom: "20px" }}
                />
              )}
              <h4 className="no-results-title">
                {activeTab === "watched"
                  ? "Henüz eğitim izlemediniz"
                  : "İzlenmemiş eğitim yok"}
              </h4>
              <p className="no-results-text">
                {activeTab === "watched"
                  ? "Tamamladığınız eğitimler burada listelenecek."
                  : "Tüm eğitimleri tamamlamışsınız, tebrikler!"}
              </p>
            </div>
          </div>
        </div>
      );
    }

    return (
      <>
        <div className="row">
          {trackItems.map((item) =>
            this.renderEducationCard(item, () => this.navigateToCourse(item.id))
          )}
        </div>

        {trackCount > 0 && trackItems.length < trackCount && (
          <div className="row mt-4">
            <div className="col-12 text-center">
              <button
                className="btn btn-outline-primary"
                onClick={() => this.loadTrackList(activeTab, false)}
                disabled={trackLoadingMore}
                style={{
                  padding: "12px 30px",
                  borderRadius: "25px",
                  border: "2px solid #3b82f6",
                  background: "transparent",
                  color: "#3b82f6",
                  fontSize: "16px",
                  fontWeight: "500",
                  cursor: trackLoadingMore ? "not-allowed" : "pointer",
                }}
              >
                {trackLoadingMore ? (
                  <>
                    <div
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      style={{ width: "1rem", height: "1rem" }}
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    Yükleniyor...
                  </>
                ) : (
                  <>
                    <TrendingUp size={18} style={{ marginRight: "8px" }} />
                    Daha Fazla Göster ({trackCount - trackItems.length} kaldı)
                  </>
                )}
              </button>
            </div>
          </div>
        )}
      </>
    );
  };

  renderItems = () => {
    const { currentItems, totalChildrenCount, isLoadingMore } = this.state;
    const items = this.getFilteredItems();

    if (items.length === 0) {
      return (
        <div className="row">
          <div className="col-12 text-center no-results">
            <div className="no-results-card">
              <BookOpen
                size={48}
                color="#64748b"
                style={{ marginBottom: "20px" }}
              />
              <h4 className="no-results-title">İçerik bulunamadı</h4>
              <p className="no-results-text">
                Bu kategoride içerik bulunmuyor veya arama kriterlerinize uygun
                sonuç yok.
              </p>
            </div>
          </div>
        </div>
      );
    }

    const categories = items.filter((item) => item.cardType === "category");
    const courses = items.filter((item) => item.cardType === "education");

    return (
      <>
        <div className="row">
          {categories.map((item) => this.renderCategoryCard(item))}
          {courses.map((item) => this.renderEducationCard(item))}
        </div>

        {totalChildrenCount > 0 && currentItems.length < totalChildrenCount && (
          <div className="row mt-4">
            <div className="col-12 text-center">
              <button
                className="btn btn-outline-primary"
                onClick={this.loadMoreItems}
                disabled={isLoadingMore}
                style={{
                  padding: "12px 30px",
                  borderRadius: "25px",
                  border: "2px solid #3b82f6",
                  background: "transparent",
                  color: "#3b82f6",
                  fontSize: "16px",
                  fontWeight: "500",
                  cursor: isLoadingMore ? "not-allowed" : "pointer",
                  transition: "all 0.3s ease",
                }}
              >
                {isLoadingMore ? (
                  <>
                    <div
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      style={{ width: "1rem", height: "1rem" }}
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    Yükleniyor...
                  </>
                ) : (
                  <>
                    <TrendingUp size={18} style={{ marginRight: "8px" }} />
                    Daha Fazla Göster (
                    {totalChildrenCount - currentItems.length} kaldı)
                  </>
                )}
              </button>
            </div>
          </div>
        )}
      </>
    );
  };

  renderLessonContent = (content) => {
    const { type, title, text_content, content_url, video_url, audio_url } = content;

    return (
      <div
        key={content.id}
        style={{
          marginBottom: "30px",
          padding: "20px",
          border: "1px solid #e2e8f0",
          borderRadius: "12px",
          background: "white",
        }}
      >
        {title && (
          <h4 style={{ marginBottom: "15px", color: "#1e293b" }}>{title}</h4>
        )}

        {type === "text" && text_content && (
          <div style={{ lineHeight: "1.6", color: "#64748b" }}>
            {text_content}
          </div>
        )}

        {type === "image" && content_url && content_url.length > 0 && (
          <div style={{ textAlign: "center" }}>
            {content_url.map((url, index) => (
              <img
                key={index}
                src={this.buildImageUrl(url)}
                alt={title || "İçerik"}
                style={{
                  maxWidth: "100%",
                  height: "auto",
                  borderRadius: "8px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  marginBottom: index < content_url.length - 1 ? "10px" : "0",
                }}
                onError={(e) => {
                  e.target.style.display = "none";
                }}
              />
            ))}
          </div>
        )}

        {type === "video" && video_url && video_url.length > 0 && (
          <div style={{ marginTop: "10px" }}>
            {video_url.map((url, index) => {
              if (url.includes("youtube.com") || url.includes("youtu.be")) {
                return (
                  <div key={index} style={{ marginBottom: "10px" }}>
                    <UniversalVideoPlayer videoUrl={url} isIlanDetay={true} />
                  </div>
                );
              } else {
                let modifiedUrl = url;

                if (url.includes("loom.com/embed/")) {
                  const separator = url.includes("?") ? "&" : "?";
                  modifiedUrl = `${url}${separator}hide_owner=true&hide_share=true&hide_title=true&hideEmbedTopBar=true`;
                }

                return (
                  <iframe
                    key={index}
                    src={modifiedUrl}
                    frameBorder="0"
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowFullScreen="true"
                    style={{
                      width: "100%",
                      height: "400px",
                      borderRadius: "8px",
                      marginBottom: "10px",
                      border: "none",
                    }}
                    title={`Video ${index + 1}`}
                  />
                );
              }
            })}
          </div>
        )}

        {type === "pdf" && content_url && content_url.length > 0 && (
          <div>
            {content_url.map((url, index) => (
              <div
                key={index}
                style={{
                  padding: "15px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: index < content_url.length - 1 ? "10px" : "0",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <div style={{ color: "#dc2626" }}>📄</div>
                  <span>
                    PDF Dosyası {content_url.length > 1 ? `${index + 1}` : ""}
                  </span>
                </div>
                <a
                  href={this.buildImageUrl(url)}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    background: "#3b82f6",
                    color: "white",
                    padding: "8px 16px",
                    borderRadius: "6px",
                    textDecoration: "none",
                    fontSize: "14px",
                  }}
                >
                  İndir
                </a>
              </div>
            ))}
          </div>
        )}

        {type === "document" && content_url && content_url.length > 0 && (
          <div>
            {content_url.map((url, index) => (
              <div
                key={index}
                style={{
                  padding: "15px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: index < content_url.length - 1 ? "10px" : "0",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <div style={{ color: "#059669" }}>📄</div>
                  <span>
                    Döküman {content_url.length > 1 ? `${index + 1}` : ""}
                  </span>
                </div>
                <a
                  href={this.buildImageUrl(url)}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    background: "#059669",
                    color: "white",
                    padding: "8px 16px",
                    borderRadius: "6px",
                    textDecoration: "none",
                    fontSize: "14px",
                  }}
                >
                  Görüntüle
                </a>
              </div>
            ))}
          </div>
        )}

        {type === "audio" && (() => {
          // Audio URL can come from content_url array or audio_url
          const audioUrls = content_url && content_url.length > 0
            ? content_url
            : (audio_url ? (Array.isArray(audio_url) ? audio_url : [audio_url]) : []);

          // Thumbnail: content'in kendi thumbnail_url'si varsa onu kullan, yoksa null (widget default icon gösterecek)
          const thumbnailImage = content.thumbnail_url
            ? this.buildImageUrl(content.thumbnail_url)
            : null;

          return audioUrls.length > 0 && (
            <div>
              {audioUrls.map((url, index) => (
                <div key={index} style={{ marginBottom: index < audioUrls.length - 1 ? "15px" : "0" }}>
                  <Mp3PlayerWidget
                    audioUrl={this.buildImageUrl(url)}
                    title={title || `Ses ${audioUrls.length > 1 ? index + 1 : ""}`}
                    subtitle={this.state.selectedCourse?.instructor || ""}
                    imageUrl={thumbnailImage}
                  />
                </div>
              ))}
            </div>
          );
        })()}
      </div>
    );
  };

  renderVideoPlayer = () => {
    const { selectedCourse, lessonContents } = this.state;

    return (
      <div className="egitimler-container">
        <div className="video-header">
          <div className="video-header-content">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <button
                    className="video-back-button"
                    onClick={this.handleBackNavigation}
                  >
                    <ArrowLeft size={16} />
                    Geri Dön
                  </button>

                  <div>
                    <h1 className="title">{selectedCourse.title}</h1>

                    <div className="video-meta">
                      {selectedCourse.instructor && (
                        <div className="video-meta-item">
                          <User size={16} />
                          {selectedCourse.instructor}
                        </div>
                      )}
                    </div>

                    {selectedCourse.description && (
                      <p className="video-description">
                        {selectedCourse.description}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="video-info-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="video-info-card">
                  <h3 className="video-info-title">Eğitim İçerikleri</h3>

                  {lessonContents.length > 0 ? (
                    <div>
                      {lessonContents
                        .filter((content) => content.isFeatured === 1)
                        .map((content) => this.renderLessonContent(content))}

                      {lessonContents
                        .filter((content) => content.isFeatured !== 1)
                        .map((content) => this.renderLessonContent(content))}

                    </div>
                  ) : (
                    <div
                      style={{
                        textAlign: "center",
                        padding: "40px",
                        color: "#64748b",
                      }}
                    >
                      <BookOpen size={48} style={{ marginBottom: "15px" }} />
                      <p>Bu eğitim için henüz içerik eklenmemiş.</p>
                    </div>
                  )}

                  {this.renderCompletionSection()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderCompletionSection = () => {
    const {
      isCompleted,
      isButtonEnabled,
      isToggling,
      remainingSeconds,
      completionMessage,
    } = this.state;

    const locked = !isCompleted && !isButtonEnabled;

    let buttonLabel;
    if (isToggling) {
      buttonLabel = "İşleniyor...";
    } else if (isCompleted) {
      buttonLabel = "Tamamlandı ✓ (Geri Çek)";
    } else if (locked) {
      buttonLabel = `Eğitimi Tamamladım (${this.formatRemaining(
        remainingSeconds
      )})`;
    } else {
      buttonLabel = "Eğitimi Tamamladım";
    }

    const bgColor = isCompleted ? "#059669" : locked ? "#94a3b8" : "#3b82f6";

    return (
      <div
        style={{
          marginTop: "30px",
          paddingTop: "25px",
          borderTop: "1px solid #e2e8f0",
          textAlign: "center",
        }}
      >
        {locked && (
          <p
            style={{
              color: "#64748b",
              fontSize: "14px",
              marginBottom: "12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "6px",
            }}
          >
            <Clock size={16} />
            Eğitimi tamamlamak için en az 10 dakika izlemelisiniz. Kalan süre:{" "}
            <strong>{this.formatRemaining(remainingSeconds)}</strong>
          </p>
        )}

        <button
          onClick={this.handleToggleCompletion}
          disabled={isToggling}
          style={{
            background: bgColor,
            color: "white",
            border: "none",
            borderRadius: "25px",
            padding: "14px 40px",
            fontSize: "16px",
            fontWeight: "600",
            cursor: isToggling ? "not-allowed" : "pointer",
            opacity: isToggling ? 0.7 : 1,
            transition: "all 0.3s ease",
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          {isCompleted ? <Trophy size={18} /> : <Target size={18} />}
          {buttonLabel}
        </button>

        {completionMessage && (
          <p
            style={{
              marginTop: "14px",
              fontSize: "14px",
              color: isCompleted ? "#059669" : "#b45309",
              fontWeight: "500",
            }}
          >
            {completionMessage}
          </p>
        )}
      </div>
    );
  };;

  renderSearchSection = () => {
    const { searchTerm, showSearchResults } = this.state;

    return (
      <div className="search-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3">
              <div
                className={`search-input-wrapper ${showSearchResults ? "active" : ""
                  }`}
              >
                <Search size={20} className="search-icon" />
                <input
                  type="text"
                  placeholder="Eğitim ara..."
                  value={searchTerm}
                  onChange={this.handleSearch}
                  onBlur={this.handleSearchBlur}
                  onFocus={() => {
                    if (searchTerm && this.state.searchResults.length > 0) {
                      this.setState({ showSearchResults: true });
                    }
                  }}
                  className="search-input"
                />
                {this.renderSearchResults()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const {
      loading,
      error,
      selectedCourse,
      hasEducationAccess,
      isCheckingAccess,
      showReferenceModal,
      navPath,
    } = this.state;

    if (isCheckingAccess || !hasEducationAccess) {
      return (
        <>
          <Loader />
          <SubHeader />
          <Header
            isLoggedIn={Cookies.get("token") != null}
            userName="Kullanıcı"
          />
          {this.renderAccessControlScreen()}
          <AddReferenceCodeModal
            isOpen={showReferenceModal}
            onClose={this.handleCloseReferenceModal}
            onSuccess={this.handleReferenceCodeSuccess}
            API_BASE={this.API_BASE}
          />
          <Footer />
        </>
      );
    }

    if (loading) {
      return (
        <>
          <Loader />
          <SubHeader />
          <Header
            isLoggedIn={Cookies.get("token") != null}
            userName="Kullanıcı"
          />
          <div className="egitimler-container">
            <div
              className="container text-center"
              style={{ padding: "100px 0" }}
            >
              <p>Eğitimler yükleniyor...</p>
            </div>
          </div>
          <Footer />
        </>
      );
    }

    if (error) {
      return (
        <>
          <Loader />
          <SubHeader />
          <Header
            isLoggedIn={Cookies.get("token") != null}
            userName="Kullanıcı"
          />
          <div className="egitimler-container">
            <div
              className="container text-center"
              style={{ padding: "100px 0" }}
            >
              <h3>Hata Oluştu</h3>
              <p>{error}</p>
              <button
                onClick={() => window.location.reload()}
                style={{
                  background: "#3b82f6",
                  color: "white",
                  padding: "10px 20px",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                }}
              >
                Tekrar Dene
              </button>
            </div>
          </div>
          <Footer />
        </>
      );
    }

    return (
      <>
        <Loader />
        <SubHeader />
        <Header isLoggedIn={Cookies.get("token") != null} />

        {selectedCourse ? (
          this.renderVideoPlayer()
        ) : (
          <div className="egitimler-container">
            <div className="egitimler-header">
              <div className="container egitimler-header-content">
                <div className="row">
                  <div className="text-center">
                    {navPath.length === 0 ? (
                      <>
                        <h6 className="egitimler-subtitle">
                          📚 EĞİTİM MERKEZİ
                        </h6>
                        <h1 className="egitimler-title">
                          Profesyonel Eğitim Programları
                        </h1>
                        <p className="egitimler-description">
                          Uzman eğitmenlerimizden özel dersler, başarı
                          hikayeleri ve kariyer gelişimi için gereken tüm eğitim
                          içerikleri
                        </p>
                      </>
                    ) : (
                      <>
                        <h1 className="egitimler-title">
                          {navPath[navPath.length - 1]?.name || "Eğitimler"}
                        </h1>
                        <p className="egitimler-description">
                          Kategori içerikleri
                        </p>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {this.renderBreadcrumbs()}

            {navPath.length === 0 && this.renderTabBar()}

            {this.state.activeTab === "all" && this.renderSearchSection()}

            <div className="main-content">
              <div className="container">
                {navPath.length === 0 && this.state.activeTab !== "all"
                  ? this.renderTrackList()
                  : this.renderItems()}
              </div>
            </div>
          </div>
        )}

        <Footer />
      </>
    );
  }
}

export default withRouter(Egitimler);
